export default {
  trainingDataHeadline: 'Dane treningowe',
  outputDataHeadline: 'Oryginał kontra przewidywanie',
  inputDataHeadline: 'Dane wejściowe',
  modelConfigHeadline: 'Parametry modelu',
};
